module.exports = __webpack_public_path__ + "media/images/action_restore-2efb57f1856d768fb2be526588dc1c46.png";